import { ourFundsList, fundTypes } from "./constants"

const OurFundsPopup = ({ popularFunds, categoryFundCount = {} }) => {
  return (
    <div className="menu-container tw-fixed tw-left-0 tw-top-[var(--top-for-menu-popup)] tw-w-full tw-z-[1000]">
      <div className='menu-popup container tw-flex tw-overflow-hidden tw-p-0'>
        <div className='tw-py-8 tw-pl-8 tw-pr-12 tw-w-2/3'>
          <div className="tw-flex tw-pb-5 tw-border-b tw-border-greyBorder">
            <h4 className="tw-uppercase tw-text-base tw-leading-5 tw-m-0 tw-font-semibold">Fund Categories</h4>
            <a href={`/mutual-funds`} title="View All Funds" className="tw-ml-auto hover:tw-underline tw-flex tw-items-center tw-gap-2 tw-text-sm
             tw-leading-6 tw-font-medium after:tw-block after:tw-w-5 after:tw-h-5 after:tw-bg-[url(/assets/images/header/arrow_right.png)] after:tw-bg-cover">View All Funds
            </a>
          </div>

          <ul className="tw-mt-5 tw-grid tw-grid-cols-2 tw-gap-y-5 tw-gap-x-8">
            {ourFundsList.map((item, i) =>
              <li key={i} className="tw-flex tw-items-center tw-gap-4">
                <img src={item.image} height={32} width={32} alt={item.title} />
                <a href={item.link} title={item.title} className="tw-text-base tw-leading-6 tw-font-medium hover:tw-underline">{item.title} {categoryFundCount[item.title] && '(' + categoryFundCount[item.title] + ')'}</a>
              </li>
            )}
          </ul>

          <ul className="tw-mt-6 tw-pt-6 tw-grid tw-grid-cols-2 tw-gap-y-5 tw-gap-x-8 tw-border-t tw-border-greyBorder">
            {fundTypes.map((item, i) =>
              <li key={i} className="tw-flex tw-items-center tw-gap-4">
                <a href={item.link} title={item.title} className="tw-flex tw-items-center tw-gap-4 tw-w-full tw-bg-[#EEF5FD] tw-py-2 tw-px-4 tw-rounded-lg after:tw-block after:tw-w-5 after:tw-h-5 after:tw-bg-[url(/assets/images/header/arrow_right.png)] after:tw-bg-cover after:tw-ml-auto hover:tw-underline">
                  <img src={item.image} height={32} width={32} alt={item.title} />
                  <span className="tw-text-base tw-leading-6 tw-font-medium">
                    {item.title} {categoryFundCount[item.id] && '(' + categoryFundCount[item.id] + ')'}
                  </span>
                </a>
              </li>
            )}
          </ul>
        </div>
        <div className="tw-w-1/3 tw-py-8 tw-pr-8 tw-pl-12 tw-bg-[#EEF5FD]">
          <div className="tw-flex tw-pb-5 tw-border-b tw-border-greyBorder">
            <h4 className="tw-uppercase tw-text-base tw-leading-5 tw-m-0 tw-font-semibold">Popular Funds</h4>
          </div>

          <div className="tw-mt-5 tw-grid tw-grid-cols-1 tw-gap-y-5">
            {popularFunds?.map((item, i) =>
              <div key={i} className="tw-flex tw-items-center tw-gap-4">
                <img src={`${process.env.REACT_APP_NEXT_PUBLIC_IMAGE_PATH}${item?.schCode}.png`} className="tw-h-8 tw-w-8 tw-object-contain tw-shrink-0" alt={item?.schDetail?.schName} />
                <a href={`/mutual-funds/${item?.schDetail?.schNameURL}`} title={item?.schDetail?.schName} className="tw-text-base tw-leading-6 hover:tw-underline">{item?.schDetail?.schName}</a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurFundsPopup